import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import LoginCard from "../../components/login-card/login-card.component";
import {
    setLoginError,
    setRedirectToLogin,
} from "../../redux/auth/auth.actions";


function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const LoginPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authToken = useSelector((state) => state.auth.authToken);
    const loginError = useSelector((state) => state.auth.loginError);
    const redirectToLogin = useSelector((state) => state.auth.redirectToLogin);

    const query = useQuery()

    let existingAWSUser = query.get("existing_aws_user")

    useEffect(() => {
        if (authToken) {
            if (loginError) {
                dispatch(setLoginError(null));
            }
            navigate("/");
        } 
        // else {
        //     navigate("/login");
        // }
    }, [authToken, loginError, dispatch, navigate]);

    useEffect(() => {
        if (redirectToLogin) {
            setTimeout(() => {
                dispatch(setRedirectToLogin(null));
            }, 5000);
        }
    }, [redirectToLogin, dispatch]);

    // useEffect(() => {
    //     const urlSearchParams = new URLSearchParams(location.search);
    //     const params = Object.fromEntries(urlSearchParams.entries());
    //     if (params.hasOwnProperty("guest")) {
    //         dispatch(setUser({ email: "Guest" }));
    //         navigate("/");
    //     }
    // }, [location, dispatch, navigate]);

    useEffect(() => {
        switch (loginError) {
            case "User is not confirmed.":
                navigate("/verify-account");
                break;
            default:
                break;
        }
    }, [loginError, navigate]);

    return (
        <div
            className="login-page-background"
            data-testid="login-page-background"
        >
            <LoginCard existingAWSUser={existingAWSUser}/>
        </div>
    );
};

export default LoginPage;
